import { Outlet } from 'react-router';

function App(): React.ReactElement {
  return <Outlet />;
}

export default App;
